var map = {
	"./cerealesansgluten.png": "d3956",
	"./eau.png": "b6c6",
	"./feculents.png": "c021",
	"./fruitsetlegumes.png": "64b2",
	"./fruitsmorceaux.png": "42b7",
	"./fruitsmurs.png": "651a",
	"./lait1age.png": "6d49",
	"./lait2age.png": "074a",
	"./laitmaternel.png": "97a9",
	"./legumesecrases.png": "2442",
	"./oeuf.png": "2ed4",
	"./oeuf100g.png": "cfc7",
	"./pain.png": "564c",
	"./patesfines.png": "0f81",
	"./poisson.png": "b5bf",
	"./poissonhachee.png": "8fd8",
	"./produitslaitiers.png": "3943",
	"./pureelegumes.png": "98dd",
	"./pureepommedeterre.png": "7621",
	"./riz.png": "e0df",
	"./semoule.png": "30ef",
	"./viande.png": "4a8d",
	"./viandehachee.png": "85d4",
	"./yaourt.png": "70ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "04b3";